export const SET_APP_INFO = 'SET_APP_INFO';
export const setAppInfo = appInfo => ({
  type: SET_APP_INFO,
  payload: appInfo,
});

export const LOAD_FILES_IN_PROGRESS = 'LOAD_FILES_IN_PROGRESS';
export const loadFilesInProgress = () => ({
  type: LOAD_FILES_IN_PROGRESS,
});

export const LOAD_FILES_SUCCESS = 'LOAD_FILES_SUCCESS';
export const loadFilesSuccess = files => ({
  type: LOAD_FILES_SUCCESS,
  payload: { files },
});

export const LOAD_FILES_FAILURE = 'LOAD_FILES_FAILURE';
export const loadFilesFailure = () => ({
  type: LOAD_FILES_FAILURE,
});

export const LOAD_FILES_FILTERED_SUCCESS = 'LOAD_FILES_FILTERED_SUCCESS';
export const loadFilesFilteredSuccess = (data) => ({
  type: LOAD_FILES_FILTERED_SUCCESS,
  payload: data,
});

export const LOAD_FILES_FILTERED_FAILURE = 'LOAD_FILES_FILTERED_FAILURE';
export const loadFilesFilteredFailure = () => ({
  type: LOAD_FILES_FILTERED_FAILURE,
});

export const SEND_INFO_SUCCESS = 'SEND_INFO_SUCCESS';
export const sendInfoSuccess = data => ({
  type: SEND_INFO_SUCCESS,
  payload: data,
});

export const SEND_INFO_FAILURE = 'SEND_INFO_FAILURE';
export const sendInfoFailure = data => ({
  type: SEND_INFO_FAILURE,
  payload: data,
});

export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const sendLoginSuccess = data => ({
  type: USER_LOGIN_SUCCESS,
  payload: data,
});

export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';
export const sendLoginFailure = data => ({
  type: USER_LOGIN_FAILURE,
  payload: data,
});

export const SET_PAGE_PARAM = 'SET_PAGE_PARAM';
export const setPageParam = () => ({
  type: SET_PAGE_PARAM,
});

export const GET_PAGE_PARAM_VALUE = 'GET_PAGE_PARAM_VALUE';
export const getPageParamValue = () => ({
  type: GET_PAGE_PARAM_VALUE,
});

export const SET_FILE_ATTRIBUTE = 'SET_FILE_ATTRIBUTE';
export const setFileAttribute = param => ({
  type: SET_FILE_ATTRIBUTE,
  payload: { param },
});

export const UPATE_FILE_REVIEW_STATUS_SUCCESS = 'UPATE_FILE_REVIEW_STATUS_SUCCESS';
export const updateFileReviewStatusSuccess = param => ({
  type: UPATE_FILE_REVIEW_STATUS_SUCCESS,
  payload: { param },
});

export const GET_REVIEW_FILES_SUCCESS = 'GET_REVIEW_FILES_SUCCESS';
export const getReviewFilesSuccess = param => ({
  type: GET_REVIEW_FILES_SUCCESS,
  payload: param,
});

export const SET_USER_INFO = 'SET_USER_INFO';
export const setUserInfo = user => ({
  type: SET_USER_INFO,
  payload: user,
});

export const GET_USER_INFO = 'GET_USER_INFO';
export const getUserInfo = () => ({
  type: GET_USER_INFO,
});

export const SET_REVIEW_INFO = 'SET_REVIEW_INFO';
export const setReviewInfo = group => ({
  type: SET_REVIEW_INFO,
  payload: group,
});

export const GET_REVIEW_INFO = 'GET_REVIEW_INFO';
export const getReviewInfo = () => ({
  type: GET_REVIEW_INFO,
});

export const GET_OUTPUT_REVIEW_STATUS_GROUP_SUCCESS = 'GET_OUTPUT_REVIEW_STATUS_GROUP_SUCCESS';
export const getOutputReviewStatusGroupSuccess = data => ({
  type: GET_OUTPUT_REVIEW_STATUS_GROUP_SUCCESS,
  payload: data,
});

export const GET_DOC_REVIEW_STATUS_GROUP_SUCCESS = 'GET_DOC_REVIEW_STATUS_GROUP_SUCCESS';
export const getDocReviewStatusGroupSuccess = data => ({
  type: GET_DOC_REVIEW_STATUS_GROUP_SUCCESS,
  payload: data,
});

export const SET_REVIEW_ASSIGN_INFO = 'SET_REVIEW_ASSIGN_INFO';
export const setReviewAssigInfo = data => ({
  type: SET_REVIEW_ASSIGN_INFO,
  payload: data,
});

export const GET_REVIEW_ASSIGN_INFO = 'GET_REVIEW_ASSIGN_INFO';
export const getReviewAssigInfo = () => ({
  type: GET_REVIEW_ASSIGN_INFO
});

export const ADD_REVIEW_ASSIGN = 'ADD_REVIEW_ASSIGN';
export const addReviewAssign = (userId) => ({
  type: ADD_REVIEW_ASSIGN,
  payload: userId,
});

export const REMOVE_REVIEW_ASSIGN = 'REMOVE_REVIEW_ASSIGN';
export const removetReviewAssign = (userId) => ({
  type: REMOVE_REVIEW_ASSIGN,
  payload: userId,
});

export const UPDATE_REVIEW_ASSIGN_SELECT = 'UPDATE_REVIEW_ASSIGN_SELECT';
export const updateReviewAssignSelect = (data) => ({
  type: UPDATE_REVIEW_ASSIGN_SELECT,
  payload: data,
});

export const UPDATE_REVIEW_ASSIGN_ALLOW_DOWNLOAD = 'UPDATE_REVIEW_ASSIGN_ALLOW_DOWNLOAD';
export const updateReviewAssignAllowDownload = (data) => ({
  type: UPDATE_REVIEW_ASSIGN_ALLOW_DOWNLOAD,
  payload: data,
});

export const SET_USERS = 'SET_USERS';
export const setUsers = users => ({
  type: SET_USERS,
  payload: users,
});

export const GET_USERS = 'GET_USERS';
export const getUsers = () => ({
  type: GET_USERS
});

export const SET_MILESTONES = 'SET_MILESTONES';
export const setMilestones = milestones => ({
  type: SET_MILESTONES,
  payload: milestones,
});

export const SET_MILESTONE_ID = 'SET_MILESTONE_ID';
export const setMilestoneId = milestones => ({
  type: SET_MILESTONE_ID,
  payload: milestones,
});

export const GET_SUMMARY_OVERALL_SUCCESS = 'GET_SUMMARY_OVERALL_SUCCESS';
export const getSummaryOverallSuccess = data => ({
  type: GET_SUMMARY_OVERALL_SUCCESS,
  payload: data,
});

export const GET_DOC_SUMMARY_OVERALL_SUCCESS = 'GET_DOC_SUMMARY_OVERALL_SUCCESS';
export const getDocSummaryOverallSuccess = data => ({
  type: GET_DOC_SUMMARY_OVERALL_SUCCESS,
  payload: data,
});

export const UPDATE_OUTPUT_FILE_STATUS_SUCCESS = 'UPDATE_OUTPUT_FILE_STATUS_SUCCESS';
export const updateOutputFileStatusSuccess = data => ({
  type: UPDATE_OUTPUT_FILE_STATUS_SUCCESS,
  payload: data,
});

export const GET_OUTPUT_FILE_TOC_INFO_SUCCESS = 'GET_OUTPUT_FILE_TOC_INFO_SUCCESS';
export const getOutputFileTocInfoSuccess = data => ({
  type: GET_OUTPUT_FILE_TOC_INFO_SUCCESS,
  payload: data,
});

export const UPDATE_STATUS_BY_RB_SUCCESS = 'UPDATE_STATUS_BY_RB_SUCCESS';
export const updateStatusByRBSuccess = data => ({
  type: UPDATE_STATUS_BY_RB_SUCCESS,
  payload: data,
});

export const UPDATE_STATUS_BY_LP_SUCCESS = 'UPDATE_STATUS_BY_LP_SUCCESS';
export const updateStatusByLPSuccess = data => ({
  type: UPDATE_STATUS_BY_LP_SUCCESS,
  payload: data,
});

export const UPDATE_OUTPUT_GROUP_DUE_DATE_SUCCESS = 'UPDATE_OUTPUT_GROUP_DUE_DATE_SUCCESS';
export const updateOutputGroupDueDateSuccess = data => ({
  type: UPDATE_OUTPUT_GROUP_DUE_DATE_SUCCESS,
  payload: data,
});

export const UPDATE_DOC_GROUP_DUE_DATE_SUCCESS = 'UPDATE_DOC_GROUP_DUE_DATE_SUCCESS';
export const updateDocGroupDueDateSuccess = data => ({
  type: UPDATE_DOC_GROUP_DUE_DATE_SUCCESS,
  payload: data,
});

export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
export const sendEmailSuccess = data => ({
  type: SEND_EMAIL_SUCCESS,
  payload: data,
});

export const CLEAR_MESSAGE_DISPLAY = 'CLEAR_MESSAGE_DISPLAY';
export const clearMessageDisplay = data => ({
  type: CLEAR_MESSAGE_DISPLAY,
  payload: data,
});

export const UPDATE_DOC_FILE_STATUS_SUCCESS = 'UPDATE_DOC_FILE_STATUS_SUCCESS';
export const updateDocFileStatusSuccess = data => ({
  type: UPDATE_DOC_FILE_STATUS_SUCCESS,
  payload: data,
});

export const UPDATE_DOC_FILE_DATA = 'UPDATE_DOC_FILE_DATA';
export const updateDocFileData = data => ({
  type: UPDATE_DOC_FILE_DATA,
  payload: data,
});

export const CHECK_OUTPUT_FILE_REMOVE_SUCCESS = 'CHECK_OUTPUT_FILE_REMOVE_SUCCESS';
export const checkOutputFileRemoveSuccess = data => ({
  type: CHECK_OUTPUT_FILE_REMOVE_SUCCESS,
  payload: data,
});

export const SET_LOGIN_INFO = 'SET_LOGIN_INFO';
export const setLoginInfo = data => ({
  type: SET_LOGIN_INFO,
  payload: data,
});

export const UPDATE_ADHOC_INFO_SUCCESS = 'UPDATE_ADHOC_INFO_SUCCESS';
export const updateAdhocInfoSuccess = data => ({
  type: UPDATE_ADHOC_INFO_SUCCESS,
  payload: data,
});

export const SEARCH_ADHOC_SUCCESS = 'SEARCH_ADHOC_SUCCESS';
export const searchAdhocSuccess = data => ({
  type: SEARCH_ADHOC_SUCCESS,
  payload: data,
});

export const GET_ADHOC_CONTROL_VALUE_SUCCESS = 'GET_ADHOC_CONTROL_VALUE_SUCCESS';
export const loadAdhocControlValueSuccess = data => ({
  type: GET_ADHOC_CONTROL_VALUE_SUCCESS,
  payload: data,
});

export const LOAD_SUPPORT_SUCCESS = 'LOAD_SUPPORT_SUCCESS';
export const loadSupportSuccess = data => ({
  type: LOAD_SUPPORT_SUCCESS,
  payload: data,
});

export const UPDATE_STUDY_LIST_SUCCESS = 'UPDATE_STUDY_LIST_SUCCESS';
export const updateStudyListSuccess = data => ({
  type: UPDATE_STUDY_LIST_SUCCESS,
  payload: data,
});

export const UPDATE_MILESTONE_LIST_SUCCESS = 'UPDATE_MILESTONE_LIST_SUCCESS';
export const updateMilestoneListSuccess = data => ({
  type: UPDATE_MILESTONE_LIST_SUCCESS,
  payload: data,
});

export const UPDATE_RELATED_TASK_LIST_SUCCESS = 'UPDATE_RELATED_TASK_LIST_SUCCESS';
export const updateRelatedTaskListSuccess = data => ({
  type: UPDATE_RELATED_TASK_LIST_SUCCESS,
  payload: data,
});

export const GET_ADHOC_REQUEST_SUCCESS = 'GET_ADHOC_REQUEST_SUCCESS';
export const getAdhocRequestSuccess = data => ({
  type: GET_ADHOC_REQUEST_SUCCESS,
  payload: data,
});

export const GET_ADHOC_REQUESTERS_SUCCESS = 'GET_ADHOC_REQUESTERS_SUCCESS';
export const getAdhocRequestersSuccess = data => ({
  type: GET_ADHOC_REQUESTERS_SUCCESS,
  payload: data,
});

export const UPDATE_ADHOC_ATTACHMENTS_SUCCESS = 'UPDATE_ADHOC_ATTACHMENTS_SUCCESS';
export const updateAdhocAttachmentsSuccess = data => ({
  type: UPDATE_ADHOC_ATTACHMENTS_SUCCESS,
  payload: data,
});

export const REMOVE_ADHOC_ATTACHMENT_SUCCESS = 'REMOVE_ADHOC_ATTACHMENT_SUCCESS';
export const removeAdhocAttachmentSuccess = data => ({
  type: REMOVE_ADHOC_ATTACHMENT_SUCCESS,
  payload: data,
});

export const UPDATE_ADHOC_IMAGE_SUCCESS = 'UPDATE_ADHOC_IMAGE_SUCCESS';
export const updateAdhocImageSuccess = data => ({
  type: UPDATE_ADHOC_IMAGE_SUCCESS,
  payload: data,
});

export const REMOVE_ADHOC_IMAGE_SUCCESS = 'REMOVE_ADHOC_IMAGE_SUCCESS';
export const removeAdhocImageSuccess = data => ({
  type: REMOVE_ADHOC_IMAGE_SUCCESS,
  payload: data,
});

export const UPDATE_REVIEW_INFO_SUCCESS = 'UPDATE_REVIEW_INFO_SUCCESS';
export const updateReviewInfoSuccess = data => ({
  type: UPDATE_REVIEW_INFO_SUCCESS,
  payload: data,
});

export const SET_SEARCH_INFO = 'SET_SEARCH_INFO';
export const setSearchInfo = data => ({
  type: SET_SEARCH_INFO,
  payload: data,
});

